/**
 * ClientMarquee — infinite horizontal marquee of client logos.
 * Mirrors the "Our Clients" carousel on live www.texcheme.com.
 *
 * Renders two copies of the logo list side-by-side and translates the track
 * from 0 → -50%, which loops seamlessly. Pauses on hover.
 */
import { motion } from "framer-motion";

export default function ClientMarquee({ clients = [], title = "Trusted by" }) {
  if (!clients.length) return null;
  const track = [...clients, ...clients];
  return (
    <section className="section-lg client-marquee-section" data-testid="client-marquee">
      <div className="wrap">
        <div className="section-eyebrow" data-testid="client-marquee-eyebrow">
          {title}
        </div>
      </div>
      <div className="client-marquee-viewport">
        <motion.div
          className="client-marquee-track"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: 30, ease: "linear", repeat: Infinity }}
        >
          {track.map((c, i) => (
            <div
              className="client-marquee-item"
              key={`${c.name}-${i}`}
              data-testid={`client-logo-${c.name.toLowerCase()}`}
              title={c.name}
            >
              <img src={c.logo} alt={c.name} loading="lazy" />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
